import { useEffect, useState } from "react";
import { checkIfUserExists, createProject, createUserAndAcceptInvite, validateInvite, validateProjectID } from "./CreateAccountFunctions";
import PageLoader from "../_shoru_shared_library/loaders/PageLoader";
import Logo from '../_media/branding/logo.svg';
import { Box, Step, StepLabel, Stepper } from "@mui/material";
import { logInWithEmailAndPassword } from "../_shoru_shared_library/firebase/firebase_setup";

function CreateAccount() {

  const url = window.location.pathname.split("/");
  const organisation = url[url.length - 2];
  const inviteId = url[url.length - 1];

  const [inviteValid, setInviteValid] = useState(null);
  const [inviteData, setInviteData] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [steps, setSteps] = useState(null);
  const [existingUserData, setExistingUserData] = useState(null);

  // User fields
  const [accountStep, setAccountStep] = useState(0);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  // Project information
  const [projectName, setProjectName] = useState('');
  const [projectId, setProjectId] = useState('');
  const [playwright, setPlaywright] = useState('');

  useEffect(() => {
    validateInvite(organisation, inviteId, setInviteValid, setInviteData);
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    if(steps || !inviteData) return;
    if(inviteData.type === 'project') {
      setSteps(['Set up account', 'Project details', 'Confirm']);
    }
    else {
      setSteps(['Set up account', 'Confirm']);
    }
  }, [inviteData])

  if(inviteValid === null || inviteData === null || steps === null) return <PageLoader />

  return (
    <Box sx={{ width: '100%' }}>
      <div className='booking-page'>
        { activeStep === steps.length? (
            <div className='booking-page-title'>
              <h2>Account Created!</h2>
              <p>You should receive an email soon to confirm your account information</p>
              <hr />
            </div>
          ) :
          activeStep === 0? (
            <div className='booking-page-title'>
              <h2>Set Up Account</h2>
              <p><b>Welcome to Shoru CastingBot</b><br/><br/>To get started, we need some information about you</p>
              <hr />
            </div>
          ) :
          activeStep === 1?
            inviteData.type === 'project'
            ? (
                <div className='booking-page-title'>
                  <h2>Your Project</h2>
                  <p>Next we need some details about your project / show!</p>
                  <button className='booking-page-back-button' onClick={() => {setActiveStep(0)}} >Back</button>
                  <hr />
                </div>
              )
            : (
                <div className='booking-page-title'>
                  <h2>Confirm Details</h2>
                  <p>Check these details over. When you're ready, click 'Accept Invite' to get started!</p>
                  <button className='booking-page-back-button' onClick={() => {setActiveStep(0)}} >Back</button>
                  <hr />
                </div>
              )
          : 
          (
            <div className='booking-page-title'>
              <h2>Confirm Details</h2>
              <p>Check these details over. When you're ready, click 'Create Account' to get started!</p>
              <button className='booking-page-back-button' onClick={() => {setActiveStep(1)}} >Back</button>
              <hr />
            </div>
          )
        }
        <Stepper sx={{width: '75%'}} activeStep={activeStep}>
          {steps.map((label, index) => {
            return (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            )
          })}
        </Stepper>
      </div>
      {activeStep === steps.length? ( <AccountCreated /> ) : (
        activeStep === 0? (
          <CreateUserPage 
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            firstName={firstName}
            setFirstName={setFirstName}
            lastName={lastName}
            setLastName={setLastName}
            setState={setActiveStep}
            accountStep={accountStep}
            setAccountStep={setAccountStep}
            setExistingUserData={setExistingUserData}
          />
        ) : 
        activeStep === 1
        ? inviteData.type === 'project'
          ? (
              <CreateProjectPage 
                projectName={projectName}
                setProjectName={setProjectName}
                projectId={projectId}
                setProjectId={setProjectId}
                playwright={playwright}
                setPlaywright={setPlaywright}
                setState={setActiveStep}
                organisation={organisation}
              />
            )
          : (
              <ConfirmUserDetails 
                organisation={organisation}
                email={email}
                firstName={firstName}
                lastName={lastName}
                name={firstName + ' ' + lastName}
                password={password}
                inviteData={inviteData}
                setState={setActiveStep}
                existingUserData={existingUserData}
              />
            )
        :
        (
          <ConfirmProjectDetails 
            organisation={organisation}
            email={email}
            firstName={firstName}
            lastName={lastName}
            name={firstName + ' ' + lastName}
            password={password}
            projectName={projectName}
            projectId={projectId}
            playwright={playwright}
            inviteData={inviteData}
            setState={setActiveStep}
            existingUserData={existingUserData}
          />
        )
      )}
    </Box>
  )

}


export default CreateAccount;




function PageFooter(props) {
  return (
    <div className='booking-page-footer' style={{...{cursor: 'pointer'}}} onClick={() => window.location.replace('/')}>
      <img src={Logo} width='50px' />
      <div>
        Powered by Shoru CastingBot
      </div>
    </div>
  )
}

function CreateUserPage(props) {

  const accountStep = props.accountStep;

  // Enter email to check if account exists
  if (accountStep === 0) {
    return (
      <div className='booking-page'>
        <div className='booking-page-form'>
          <p>Your Email *</p>
          <input type='text' placeholder='e.g. me@myemail.com' value={props.email} style={{borderColor: (props.email === '')? null : (props.email.split('@').length !== 2)? '#e74c3c' : '#2ecc71'}} onChange={(e) => {props.setEmail(e.target.value.toLowerCase().trim())}}/>
          <button className='booking-page-button' style={{backgroundColor: 
            (
              props.email.split('@').length !== 2
            )? '#444444' : '#0984e3'
          }} onClick={async() => {
            if(props.email.split('@').length !== 2) alert('Invalid email');
            else {
              checkIfUserExists(props.email, props.setExistingUserData).then((userExists) => {
                if(userExists) { props.setAccountStep(2); }
                else { props.setAccountStep(1); }
              })
            }
          }}>Check Details</button>
        </div>
      </div>
    )
  }
  // Account does not exist = create new account
  else if(accountStep === 1) {
    return (
      <div className='booking-page'>
        <div className='booking-page-form'>
          <p>Your Email *</p>
          <input type='text' placeholder='e.g. me@myemail.com' value={props.email} style={{borderColor: (props.email === '')? null : (props.email.split('@').length !== 2)? '#e74c3c' : '#2ecc71'}} onChange={(e) => {props.setEmail(e.target.value.toLowerCase().trim()); props.setAccountStep(0); props.setExistingUserData(null)}}/>
          <p>First Name *</p>
          <input type='text' placeholder='e.g. Jane' value={props.firstName} style={{borderColor: (props.firstName === '')? null : '#2ecc71'}} onChange={(e) => props.setFirstName(e.target.value.trim())} />
          <p>Last Name *</p>
          <input type='text' placeholder='e.g. Doe' value={props.lastName} style={{borderColor: (props.lastName === '')? null : '#2ecc71'}} onChange={(e) => props.setLastName(e.target.value.trim())} />
          <p>Password *</p>
          <input type='password' value={props.password} style={{borderColor: (props.password === '')? null : (props.password.length < 8)? '#e74c3c' : '#2ecc71'}} onChange={(e) => props.setPassword(e.target.value)} />
          <p>Confirm Password *</p>
          <input type='password' value={props.confirmPassword} style={{borderColor: (props.confirmPassword === '')? null : (props.password !== props.confirmPassword || props.password.length < 8)? '#e74c3c' : '#2ecc71'}} onChange={(e) => props.setConfirmPassword(e.target.value)} />
          <button className='booking-page-button' style={{backgroundColor: 
            (
              props.email.split('@').length !== 2
              || props.firstName === ''
              || props.lastName === ''
              || props.password !== props.confirmPassword 
              || props.password.length < 8
            )? '#444444' : '#0984e3'
          }} onClick={() => {
            if(props.email.split('@').length !== 2)           alert('Invalid email');
            else if(props.firstName === '')                   alert('First name must be provided');
            else if(props.lastName === '')                    alert('Last Name must be provided');
            else if(props.password.length < 8)                alert('Password must contain at least 8 characters');
            else if(props.confirmPassword !== props.password) alert('Passwords do not match')
            else                                              props.setState(1);
          }}>Next</button>
        </div>
        <hr/>
        <PageFooter />
      </div>
    )
  }
  // Account exists = verify login
  else {
    return (
      <div className='booking-page'>
        <div className='booking-page-form'>
          <p>Your Email *</p>
          <input type='text' placeholder='e.g. me@myemail.com' value={props.email} style={{borderColor: (props.email === '')? null : (props.email.split('@').length !== 2)? '#e74c3c' : '#2ecc71'}} onChange={(e) => {props.setEmail(e.target.value.toLowerCase().trim()); props.setAccountStep(0); props.setExistingUserData(null)}}/>
          <p>Password *</p>
          <input type='password' value={props.password} onChange={(e) => props.setPassword(e.target.value)} />
          <button className='booking-page-button' style={{backgroundColor: '#0984e3'}} 
          onClick={async() => {
            logInWithEmailAndPassword(props.email, props.password, (x) => {if(!x === true) alert(x)}).then((successful) => {
              if(successful) {
                props.setState(1);
              }
            })
          }}>Sign In</button>
        </div>
      </div>
    )
  }

}

function CreateProjectPage(props) {

  return (
    <div className='booking-page'>
      <div className='booking-page-form'>
        <p>Project Name *</p>
        <input type='text' value={props.projectName} style={{borderColor: (props.projectName === '')? null : '#2ecc71'}} onChange={(e) => {props.setProjectName(e.target.value); props.setProjectId(e.target.value.toLowerCase().trim().replaceAll(' ','-').replace(/[&\/\\#,+()$~%.'’":!*?<>{}]/g, ''))}}/>
        <div style={{...{fontSize: '12px', marginBottom: '30px'},...{color: '#999999'}}}>
          <span style={{color: '#ff7675'}}><b>Please provide <u>ONLY THE NAME</u> of your show above.</b><br/>Do <b><u>NOT</u></b> include words such as 'Auditions', 'ODN', 'Fringe' etc. in your project name!</span>
        </div>
        <p>Project ID *</p>
        <input type='text' value={props.projectId} onChange={(e) => {props.setProjectId(e.target.value.toLowerCase().replaceAll(' ','-').replace(/[&\/\\#,+()$~%.'":!*?<>{}]/g, ''))}}/>
        <div style={{...{fontSize: '12px', marginBottom: '30px'},...{color: '#999999'}}}>
          Your Project ID is unique to your show, and will appear in all public Shoru links to your project (e.g. your CastingBot booking page). <b>You can change it above.</b> We recommend you make it short and easily identifiable!
        </div>
        <p>Playwright *</p>
        <input style={{marginBottom: '20px'}} placeholder='John Doe' type='text' value={props.playwright} onChange={(e) => {props.setPlaywright(e.target.value)}}/>
        <button className='booking-page-button' style={{backgroundColor: (props.projectName === '')? '#444444' : '#0984e3'
        }} onClick={async() => {
          if(props.projectName.trim() === '' || props.projectId.trim() === '' || props.playwright.trim() === '')           alert('All fields must be filled in!');
          else
          {
            // Safety check to prevent bypassing of ID name restrictions
            props.setProjectId(getProjectIdFrom(props.projectId))
            const validId = await validateProjectID(props.organisation, getProjectIdFrom(props.projectId));
            if(validId)
            {
              props.setProjectName(props.projectName.trim())
              props.setState(2);
            }
          }
        }}>Validate Project Details</button>
      </div>
      <hr/>
      <PageFooter />
    </div>
  )

}

function ConfirmProjectDetails(props) {

  return (
    <div className='booking-page'>
      <h4 style={{...{display:'flex'},...{justifyContent:'space-between'}}}> <b>Email:</b> {props.email}</h4>
      {props.existingUserData === null? <h4 style={{...{display:'flex'},...{justifyContent:'space-between'}}}> <b>Name: </b> {props.name}</h4> : null}
      <h4 style={{...{display:'flex'},...{justifyContent:'space-between'}}}> <b>Project:</b> {props.projectName}</h4>
      <h4 style={{...{display:'flex'},...{justifyContent:'space-between'}}}> <b>Project ID:</b> {props.projectId}</h4>
      <h4 style={{...{display:'flex'},...{justifyContent:'space-between'}}}> <b>Playwright:</b> {props.playwright}</h4>

      <button className='booking-page-button' style={{backgroundColor: (props.projectName === '')? '#444444' : '#0984e3'
      }} onClick={async() => {
        createProject(props.organisation, props.email, props.firstName, props.lastName, props.password, props.projectName, props.projectId, props.playwright, props.inviteData, props.setState, props.existingUserData);
      }}>{props.existingUserData === null? 'Create Account & Project' : 'Create Project'}</button>

      <hr/>
      <PageFooter />
    </div>
  )

}


function ConfirmUserDetails(props) {

  return (
    <div className='booking-page'>
      <h4 style={{...{display:'flex'},...{justifyContent:'space-between'}}}> <b>Email:</b> {props.email}</h4>
      {props.existingUserData === null? <h4 style={{...{display:'flex'},...{justifyContent:'space-between'}}}> <b>Name: </b> {props.name}</h4> : null}
      <h4 style={{...{display:'flex'},...{justifyContent:'space-between'}}}> <b>Joining Organisation:</b> {props.organisation}</h4>

      <button className='booking-page-button' style={{backgroundColor: '#0984e3'
      }} onClick={async() => {
        createUserAndAcceptInvite(props.organisation, props.email, props.firstName, props.lastName, props.password, props.inviteData, props.setState, props.existingUserData);
      }}>{props.existingUserData === null? 'Create Account & Accept Invite' : 'Accept Invite'}</button>

      <hr/>
      <PageFooter />
    </div>
  )

}

function AccountCreated(props) {

  return (
    <div className='booking-page'>
      <button className='booking-page-button' onClick={() => {
        window.location.replace('/console');
      }}>Go to CastingBot</button>

      <hr/>
      <PageFooter />
    </div>
  )

}

const getProjectIdFrom = (name) => {
  return name.toLowerCase().trim().replaceAll(' ','-').replace(/[&\/\\#,+()$~%.'":!*?<>{}]/g, '')
}